export default __webpack_public_path__ + "static/media/SWT0400.34I-26997_-16397_0.ad780dac.jpg";